<template>
	<div class="position-relative">
		<div class="cart">
			<div class="icon-cart" :class="{ invert: !invert }"></div>
			<div class="badge" v-if="cart.totalQty > 0">{{ cart.totalQty }}</div>
		</div>
		<div class="product-added" :class="{ show: showAlert }" v-if="productAdded">
			<h2><i class="icon icon-check icon-sm invert mr-2"></i> Producto añadido correctamente al carrito</h2>
			<div class="data mt-3">
				<div v-if="productAdded.product && productAdded.product.image" class="image mr-3" :style="'background-image:url(' + productAdded.product.image.url + ')'"></div>
				<div>
					<div class="title">{{ productAdded.product.name }}</div>
					<div class="price mt-2">
						<span class="currency">U$S</span>
						<span class="amount">{{ productAdded.priceUnit }}</span>
						<small class="ml-1">IVA INC</small>
					</div>
				</div>
			</div>
			<div class="d-flex flex-wrap w-100 justify-content-between mt-3">
				<router-link tag="a" to="/productos" class="btn btn-secondary ">Seguir comprando</router-link>
				<router-link tag="a" to="/checkout" class="btn btn-primary ">Finalizar compra</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CartNavbar',
	props: ['invert'],
	data() {
		return {
			cantProducts: 0,
			cart: null,
			loaded: false,
			showAlert: false,
			productAdded: null,
		}
	},

	watch: {
		'$store.getters.cart': {
			handler: function(val, oldVal) {
				if (val.lastAdded) this.productAdded = val.lastAdded

				const cantProducts = val.totalQty

				if (!this.cantProducts) this.cantProducts = 0
				// // uso el loaded, para que la primera carga del watch, no muestre el cartel de añadido
				if (this.loaded && cantProducts > this.cantProducts) {
					this.showProductAdded()
				}
				this.cantProducts = cantProducts
				this.cart = val
				// // console.log(val, oldVal)

				this.loaded = true
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {
		showProductAdded() {
			this.showAlert = true
			// setTimeout(() => {
			// 	this.showAlert = false
			// }, 1200)
		},
	},
}
</script>
<style scoped>
.cart {
	position: relative;
}

.icon-cart {
	width: 26px;
	height: 26px;
	background-size: contain;
	background-image: url('~@/assets/img/icon-cart.png');
}
.badge {
	position: absolute;
	top: -16px;
	right: -16px;
	width: 22px;
	height: 22px;
	font-size: 12px;
	padding: 0px;
	font-weight: 400;
	border-radius: 15px;
	background-color: #8ad1e4;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-added {
	position: fixed;

	width: 410px;
	height: 230px;
	top: -500px;
	right: calc(50% - 205px);
	padding: 12px 18px;
	background-color: #fff;
	color: #000;
	font-weight: 400;
	font-size: 14px;
	transform: translateX(500%);
	-webkit-transform: translateX(500%);

	-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
	-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
	box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
}
.product-added.show {
	animation: slide-in 0.5s forwards;
	-webkit-animation: slide-in 0.5s forwards;
	top: calc(50% - 100px);
}

.product-added h2 {
	font-size: 17px;
	font-weight: 600;
}
.product-added .image {
	width: 92px;
	height: 92px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
}
.product-added .data {
	display: flex;
	align-items: center;
	padding: 0px;
}
.product-added .title {
	font-size: 20px;
	line-height: 20px;
}
.product-added .price {
	font-size: 15px;
	line-height: 20px;
}
.product-added .price .currency {
	font-size: 14px;
	font-weight: 600;
}
.product-added .price .amount {
	font-size: 20px;
	font-weight: 600;
}

@keyframes slide-in {
	100% {
		transform: translateX(0%);
	}
}

@-webkit-keyframes slide-in {
	100% {
		-webkit-transform: translateX(0%);
	}
}
</style>
